import {
    EmailFieldRHF,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface ITogglSetupFieldsPanel {
}
export const TogglSetupFieldsPanel: FC<
    ITogglSetupFieldsPanel
> = ({ }) => {

    return (
        <>
            <EmailFieldRHF
                label="Email"
                id="email"
                testId={`toggl-setup-email`}
                labelPosition={LabelPosition.Top}
                labelColumns={4}
                fieldColumns={8}
            // required
            />
            <RHookFormPasswordFieldWithLabel
                id="password"
                testId={`password`}
                label="Password"
                labelPosition={LabelPosition.Top}
            // required
            />
            
        
        </>
    );
};
